module.exports = __webpack_public_path__ + "static/footer-bg-9331d9d40f5b2c58723a25423a4e82c9.png";